module.exports = __webpack_public_path__ + "img/logo-main2.e4dbc40e.png";